import { ComponentProps } from "react";

import { Ds } from "@accurx/design";
import { Pill } from "@accurx/inbox-design-library";
import {
    TEMPLATE_FILTER_METADATA,
    TEMPLATE_METADATA,
    TEMPLATE_TYPES,
    TemplatesFilter,
} from "domains/message-component/components/Compose/components/MessageTemplates/types/templateTypes";

type TemplateFilterSelectorProps = {
    value: TemplatesFilter;
    onChange?: (value: TemplatesFilter) => void;
    onClick?: ComponentProps<typeof Pill.Dropdown>["onClick"];
};

export const TemplateFilterSelector = ({
    value,
    onChange,
    onClick,
}: TemplateFilterSelectorProps) => {
    const handleChange = (newValue: TemplatesFilter) => {
        onChange?.(newValue);
    };

    return (
        <Ds.DropdownMenu>
            <Ds.DropdownMenu.Trigger asChild>
                <Pill.Dropdown
                    radius="full"
                    aria-label={"Filter templates and questionnaires"}
                    onClick={onClick}
                >
                    <Pill.Icon
                        name={TEMPLATE_FILTER_METADATA[value].icon}
                        colour="blue"
                        theme="Line"
                        props={{
                            "aria-hidden": true,
                        }}
                    />
                    <Pill.Text>
                        {TEMPLATE_FILTER_METADATA[value].selectedFilterLabel}
                    </Pill.Text>
                </Pill.Dropdown>
            </Ds.DropdownMenu.Trigger>
            <Ds.DropdownMenu.Content align="start">
                <Ds.DropdownMenu.Header>
                    <Ds.Text size="small" weight="bold">
                        Filter
                    </Ds.Text>
                </Ds.DropdownMenu.Header>

                <Ds.DropdownMenu.RadioGroup
                    value={value}
                    onValueChange={(value) =>
                        handleChange(value as TemplatesFilter)
                    }
                >
                    <Ds.DropdownMenu.RadioItem value="All">
                        <Ds.Flex alignItems="center" gap="1">
                            <Ds.Icon
                                name={TEMPLATE_FILTER_METADATA["All"].icon}
                                size="small"
                            />
                            <Ds.Text size="small">Show all</Ds.Text>
                        </Ds.Flex>
                    </Ds.DropdownMenu.RadioItem>

                    <Ds.DropdownMenu.Divider />

                    {TEMPLATE_TYPES.map((type) => (
                        <Ds.DropdownMenu.RadioItem key={type} value={type}>
                            <Ds.Flex alignItems="center" gap="1">
                                <Ds.Icon
                                    name={TEMPLATE_METADATA[type].icon}
                                    size="small"
                                />
                                <Ds.Text size="small">
                                    {
                                        TEMPLATE_METADATA[type]
                                            .selectedFilterLabel
                                    }
                                </Ds.Text>
                            </Ds.Flex>
                        </Ds.DropdownMenu.RadioItem>
                    ))}
                </Ds.DropdownMenu.RadioGroup>
            </Ds.DropdownMenu.Content>
        </Ds.DropdownMenu>
    );
};
